import { type HttpBadStatusCodeError, type UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from '@/packages/query-state/shared/store/EQueryKeys';

import { type TGetBannerEnrichmentsRequest } from '@/repositories/generated/shared/ad-banner/v1/get-banner-enrichments';

export type QueryError = UnknownError | HttpBadStatusCodeError;

export type QueryKey = [EQueryKeys.AdBanner__V1_GetBannerEnrichments, TGetBannerEnrichmentsRequest];

export const getQueryKey = (params: QueryKey[1]): QueryKey => [EQueryKeys.AdBanner__V1_GetBannerEnrichments, params];
